import { Injectable, signal } from '@angular/core';
import { AuthResponse, Role } from './models';

const TOKEN_KEY = 'lm_token';
const USER_KEY = 'lm_user';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _user = signal<{ id: number; email: string; role: Role; nom: string; prenom: string } | null>(this.loadUser());
  readonly user = this._user.asReadonly();

  get token(): string | null { return localStorage.getItem(TOKEN_KEY); }
  get isLoggedIn(): boolean { return this.token !== null; }
  get role(): Role | null { return this._user()?.role ?? null; }

  saveAuth(r: AuthResponse): void {
    localStorage.setItem(TOKEN_KEY, r.token);
    const u = { id: r.userId, email: r.email, role: r.role, nom: r.nom, prenom: r.prenom };
    localStorage.setItem(USER_KEY, JSON.stringify(u));
    this._user.set(u);
  }

  logout(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    this._user.set(null);
  }

  private loadUser() {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  }
}
